/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Banner de trial activo en Facturación (promo). Lapsed/expired → solo PlanLapsedModal.
 */
import React from 'react';
import { Text, View } from 'react-native';
import {
  formatGrantExpiryLabel,
  parseActivePlanGrant,
  planDisplayName,
  trialBannerSubtitle,
  trialUrgencyPhase,
  type ActivePlanGrant,
} from '../../../../../../shared/billing-catalog';
import { billingStyles as styles } from '../billingScreen.styles';

type SignupTrialPromoBannerProps = {
  grant: ActivePlanGrant | null | undefined;
};

function bannerStyleForUrgency(urgency: ReturnType<typeof trialUrgencyPhase>) {
  if (urgency === 'last_day') return [styles.banner, styles.bannerWarning];
  if (urgency === 'soon') return [styles.banner, styles.bannerAccent];
  return [styles.banner, styles.bannerSuccess];
}

export function SignupTrialPromoBanner({ grant }: SignupTrialPromoBannerProps) {
  const parsed = parseActivePlanGrant(grant);
  if (!parsed) return null;
  const urgency = trialUrgencyPhase(parsed.expires_at);
  const planName = planDisplayName(parsed.plan_code);
  const dateLabel = formatGrantExpiryLabel(parsed.expires_at);
  const urgencyLine =
    urgency === 'normal' ? null : trialBannerSubtitle(parsed.expires_at, planName);

  return (
    <View style={bannerStyleForUrgency(urgency)}>
      <Text style={styles.bannerMeta}>Prueba del plan</Text>
      <Text style={styles.bannerTitle}>
        Tenés el plan <Text style={styles.bannerPlanName}>{planName}</Text> en prueba
      </Text>
      <Text style={styles.bannerBody}>
        Sin cargo hasta el {dateLabel}.
        {urgencyLine ? ` ${urgencyLine}.` : null} Si no te suscribís, seguís en Gratis.
        Tus datos quedan.
      </Text>
    </View>
  );
}
